// --
// Grid types
// --
var UitkLayoutGridColumnRows = [1, 2, 3, 4, 6, 8, 12];
var EgdsSizingLengths = ['0x', '0x__half', '0x__quarter', '1x', '1x__half', '2x', '3x', '3x__half', '4x', '4x__half', '5x', '6x', '7x', '8x', '9x', '10x', '11x', '12x', '13x', '14x', '15x', '16x', '17x', '18x', '24x', '30x', '37x', '38x', '40x', '48x', '70x', '72x', '76x', '88x', '96x', '104x', '112x', '120x', '180x', '312x', '500x'];
var UitkLayoutGridAligns = ['start', 'end', 'center', 'stretch'];
var UitkLayoutGridPlaces = ['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly'];
var UitkLayoutGridAutoFlows = ['row', 'column', 'dense', 'row-dense', 'column-dense'];
/**
 * Keyword block-size (height) sizes
 *
 * @type 'full_size'
 */
var UitkLayoutGridBlockSizes = ['full_size'];
// --
// Grid item types
// --
var UitkLayoutGridSpans = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var UitkLayoutGridItemPlaceSelfs = ['start', 'end', 'center', 'stretch'];
export { EgdsSizingLengths, UitkLayoutGridAligns, UitkLayoutGridAutoFlows, UitkLayoutGridBlockSizes, UitkLayoutGridColumnRows, UitkLayoutGridItemPlaceSelfs, UitkLayoutGridPlaces, UitkLayoutGridSpans };